module.exports = __webpack_public_path__ + "static/media/logo.3cd28431.svg";